module.exports = __webpack_public_path__ + "static/media/step1.b3e93962.svg";